/** @jsx jsx */
import { Loader, Pagination, Stack } from "@eworkit/iris";
import { EmptyList } from "components-new/lists";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { jsx } from "theme-ui";

import { IPageableShortConsultantProfile, IShortConsultantProfile } from "@/data/consultant-profiles";
import { IPageableFetcherRenderProps } from "@/hooks/http";

import { TeamRecord } from "./TeamRecord";

interface TeamListProps extends IPageableFetcherRenderProps<IShortConsultantProfile, IPageableShortConsultantProfile> {}

export const TeamList: FC<TeamListProps> = ({ payload, working, changePage, fetch, changePageSize }) => {
  const { t } = useTranslation("session");

  if (working) {
    return <Loader size="xl" color="vg500" />;
  }

  if (!payload) {
    return null;
  }

  if (payload.totalElements === 0) {
    return <EmptyList header={t("COMPANY.TEAM.EMPTY_HEADER")} subheader={t("COMPANY.TEAM.EMPTY_SUBHEADER")} />;
  }

  return (
    <Stack gap="lg" sx={{ width: "100%" }}>
      <Stack gap="xs" sx={{ width: "100%" }}>
        {payload.content.map(cp => (
          <TeamRecord key={cp.id} record={cp.data} onUpdate={fetch} />
        ))}
      </Stack>

      {payload.totalPages > 1 && (
        <Pagination
          pagesCount={payload.totalPages}
          activeIndex={payload.number}
          onChangeIndex={changePage}
          pageSize={payload.size}
          onChangePageSize={changePageSize}
          resultsLabel=""
        />
      )}
    </Stack>
  );
};
